import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { saveSurvey, checkDuplicateAddress } from './dynamodb';

function Survey() {
  const [formData, setFormData] = useState({
    address: '',
    satisfaction: '',
    continueFirstPort: '',
    rightToManage: '',
    suggestions: ''
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('success');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showIntro, setShowIntro] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaValue) {
      setErrorMessage('Please complete the CAPTCHA verification.');
      setModalType('error');
      setShowModal(true);
      return;
    }
    
    setIsSubmitting(true);
    try {
      // Check for duplicate address
      const isDuplicate = await checkDuplicateAddress(formData.address);
      if (isDuplicate) {
        setErrorMessage('This address has already submitted a survey. Each household may only submit once.');
        setModalType('error');
        setShowModal(true);
        return;
      }
      
      await saveSurvey(formData);
      setModalType('success');
      setShowModal(true);
      setFormData({ address: '', satisfaction: '', continueFirstPort: '', rightToManage: '', suggestions: '' });
      setCaptchaValue(null);
    } catch (error) {
      setErrorMessage('There was an error submitting your survey. Please try again.');
      setModalType('error');
      setShowModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="survey-container">
      <div className="survey-pattern"></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 col-12">
            <div className="modern-form p-5 fade-in">
              <div className="text-center">
                <div className="survey-icon mx-auto">📋</div>
                <h1 className="survey-title">Resident Survey</h1>
                <p className="survey-subtitle">Help us improve your living experience at Meadow Bank</p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label">House number and street name: *</label>
                  <input type="text" className="form-control" 
                         placeholder="e.g. 15 Meadow Bank" 
                         value={formData.address}
                         onChange={(e) => setFormData({...formData, address: e.target.value})}
                         required />
                </div>

                <div className="mb-4">
                  <label className="form-label">How satisfied are you with the management company FirstPort? *</label>
          <select className="form-select" value={formData.satisfaction} 
                  onChange={(e) => setFormData({...formData, satisfaction: e.target.value})}
                  required>
            <option value="">Select...</option>
            <option value="very-satisfied">Very Satisfied</option>
            <option value="satisfied">Satisfied</option>
            <option value="neutral">Neutral</option>
            <option value="dissatisfied">Dissatisfied</option>
          </select>
        </div>

                <div className="mb-4">
                  <label className="form-label">Do you want to continue to use FirstPort? *</label>
                  <select className="form-select" value={formData.continueFirstPort} 
                          onChange={(e) => setFormData({...formData, continueFirstPort: e.target.value})}
                          required>
                    <option value="">Select...</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                    <option value="unsure">Unsure</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="form-label">Would you like to exercise our right to manage by starting our own management company and then leaving FirstPort? *</label>
                  <select className="form-select" value={formData.rightToManage} 
                          onChange={(e) => setFormData({...formData, rightToManage: e.target.value})}
                          required>
                    <option value="">Select...</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                    <option value="unsure">Unsure</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="form-label">Additional suggestions: (Optional)</label>
          <textarea className="form-control" rows="3" value={formData.suggestions}
                    onChange={(e) => setFormData({...formData, suggestions: e.target.value})}></textarea>
        </div>
                <div className="mb-4 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6Ldifl0pAAAAADZCvzJSAm-wBdsmx0flhew4zXhT"
                    onChange={setCaptchaValue}
                    size="compact"
                  />
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-survey" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit Survey'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      {showIntro && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div className="col-lg-6 col-md-8 col-10">
            <div className="modern-form p-5" style={{backgroundColor: '#dc3545', color: '#ffd700'}}>
              <div className="text-center">
                <h1 className="survey-title" style={{color: '#ffd700'}}>Please Read</h1>
              </div>
              <div className="mb-4">
                <p className="mb-3">
                  With majority resident support (51% or greater), we have the legal right to exercise our Right to Manage and transition away from FirstPort to:
                </p>
                <ol className="mb-3">
                  <li>Engage an alternative professional management company</li>
                  <li>Establish our own resident management company with direct contractor appointments for grounds maintenance, facilities management, and waste services</li>
                </ol>
                <p className="mb-0">
                  This approach would provide enhanced resident control over service delivery and potentially deliver more predictable annual service charges.
                </p>
              </div>
              <div className="text-center">
                <button className="btn" style={{backgroundColor: 'white', color: '#dc3545', border: 'none', padding: '10px 20px', borderRadius: '5px'}} onClick={() => setShowIntro(false)}>
                  Continue to Survey
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {showModal && (
        <div className="success-modal" onClick={() => setShowModal(false)}>
          <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className={`success-icon ${modalType === 'error' ? 'error-icon' : ''}`}>
              {modalType === 'success' ? '✓' : '⚠'}
            </div>
            <h3 className="mb-3">
              {modalType === 'success' ? 'Survey Submitted!' : 'Submission Error'}
            </h3>
            <p className="text-muted mb-4">
              {modalType === 'success' 
                ? 'Thank you for your feedback. Your response has been recorded.' 
                : errorMessage || 'There was an error submitting your survey. Please try again.'}
            </p>
            <button className="btn btn-survey" onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Survey;